//import * as React from "react";
import React, { useRef, useEffect, useState } from "react";

import Barra from "./Barra"


//{ "pieza":12, id_prod :0, color:"white", partes:  "00000", interno: false},
//{pieza: 11, id_prod: 0, color: 'white', partes: '00000', interno: false}
//------parametros inicializados

const RenderBarras1 = ({ data=[] }) => {
  //"#fff"
  //let color= props.color || '#fff';
  //console.log('data');
  //console.log(data);
   
  return (
    <span>
    { data.map((item,index) =>(
      <div key={index}>

        {item.pieza=== 18 &&
        <Barra pieza={18}  backColor={item.colorb1} width={60} height={11} style={{top: '282', left: '76',transform: 'rotate(95deg)' }} className="abs" />
        }
        {item.pieza=== 17 &&
        <Barra pieza={17}  backColor={item.colorb1} width={60} height={11} style={{top: '240', left: '80',transform: 'rotate(95deg)' }} className="abs" />
        }
        {item.pieza=== 16 &&
        <Barra pieza={16}  backColor={item.colorb1} width={60} height={11} style={{top: '195', left: '86',transform: 'rotate(96deg)' }} className="abs" />
        }
        {item.pieza=== 15 &&
        <Barra pieza={15}  backColor={item.colorb1} width={50} height={11} style={{top: '156', left: '96',transform: 'rotate(96deg)' }} className="abs" />
        }
        {item.pieza=== 14 &&
        <Barra pieza={14}  backColor={item.colorb1} width={40} height={11} style={{top: '129', left: '106',transform: 'rotate(100deg)' }} className="abs" />
        }
        {item.pieza=== 13 &&
        <Barra pieza={13}  backColor={item.colorb1} width={30} height={11} style={{top: '109', left: '118',transform: 'rotate(115deg)' }} className="abs" />
        }
        {item.pieza=== 12 &&
        <Barra pieza={12}  backColor={item.colorb1} width={25} height={11} style={{top: '102', left: '132',transform: 'rotate(160deg)' }} className="abs" />
        }
        {item.pieza=== 11 &&
        <Barra pieza={11}  backColor={item.colorb1} width={25} height={11} style={{top: '102', left: '150',transform: 'rotate(180deg)' }} className="abs" />
        }

        {item.pieza=== 21 &&
        <Barra pieza={21}  backColor={item.colorb1} width={25} height={11} style={{top: '102', left: '170',transform: 'rotate(180deg)' }} className="abs" />
        }
        {item.pieza=== 22 &&
        <Barra pieza={22}  backColor={item.colorb1} width={25} height={11} style={{top: '106', left: '189',transform: 'rotate(200deg)' }} className="abs" />
        }
        {item.pieza=== 23 &&
        <Barra pieza={23}  backColor={item.colorb1} width={25} height={11} style={{top: '117', left: '201',transform: 'rotate(230deg)' }} className="abs" />
        }
        {item.pieza=== 24 &&
        <Barra pieza={24}  backColor={item.colorb1} width={40} height={11} style={{top: '142', left: '201',transform: 'rotate(255deg)' }} className="abs" />
        }
        {item.pieza=== 25 &&
        <Barra pieza={25}  backColor={item.colorb1} width={50} height={11} style={{top: '175', left: '203',transform: 'rotate(260deg)' }} className="abs" />
        }
        {item.pieza=== 26 &&
        <Barra pieza={26}  backColor={item.colorb1} width={60} height={11} style={{top: '218', left: '202',transform: 'rotate(263deg)' }} className="abs" />
        }
        {item.pieza=== 27 &&
        <Barra pieza={27}  backColor={item.colorb1} width={60} height={11} style={{top: '266', left: '206',transform: 'rotate(263deg)' }} className="abs" />
        }
        {item.pieza=== 28 &&
        <Barra pieza={28}  backColor={item.colorb1} width={60} height={11} style={{top: '307', left: '211',transform: 'rotate(263deg)' }} className="abs" />
        }
        {/**--------------------- parte de abajo------------------------------------------ */}
        {item.pieza=== 48 &&
        <Barra pieza={48}  backColor={item.colorb1} width={60} height={11} style={{top: '77', left: '388',transform: 'rotate(85deg)' }} className="abs" />
        }
        {item.pieza=== 47 &&
        <Barra pieza={47}  backColor={item.colorb1} width={60} height={11} style={{top: '119', left: '394',transform: 'rotate(85deg)' }} className="abs" />
        }
        {item.pieza=== 46 &&
        <Barra pieza={46}  backColor={item.colorb1} width={60} height={11} style={{top: '165', left: '399',transform: 'rotate(85deg)' }} className="abs" />
        }
        {item.pieza=== 45 &&
        <Barra pieza={45}  backColor={item.colorb1} width={50} height={11} style={{top: '208', left: '408',transform: 'rotate(80deg)' }} className="abs" />
        }
        {item.pieza=== 44 &&
        <Barra pieza={44}  backColor={item.colorb1} width={50} height={11} style={{top: '239', left: '414',transform: 'rotate(70deg)' }} className="abs" />
        }
        {item.pieza=== 43 &&
        <Barra pieza={43}  backColor={item.colorb1} width={30} height={11} style={{top: '264', left: '435',transform: 'rotate(50deg)' }} className="abs" />
        }
        {item.pieza=== 42 &&
        <Barra pieza={42}  backColor={item.colorb1} width={25} height={11} style={{top: '275', left: '450',transform: 'rotate(30deg)' }} className="abs" />
        }
        {item.pieza=== 41 &&
        <Barra pieza={41}  backColor={item.colorb1} width={25} height={11} style={{top: '280', left: '463',transform: 'rotate(0deg)' }} className="abs" />
        }

        {item.pieza=== 31 &&
        <Barra pieza={31}  backColor={item.colorb1} width={25} height={11} style={{top: '280', left: '483',transform: 'rotate(0deg)' }} className="abs" />
        }
        {item.pieza=== 32 &&
        <Barra pieza={32}  backColor={item.colorb1} width={25} height={11} style={{top: '279', left: '496',transform: 'rotate(-20deg)' }} className="abs" />
        }
        {item.pieza=== 33 &&
        <Barra pieza={33}  backColor={item.colorb1} width={30} height={11} style={{top: '273', left: '502',transform: 'rotate(-50deg)' }} className="abs" />
        }
        {item.pieza=== 34 &&
        <Barra pieza={34}  backColor={item.colorb1} width={45} height={11} style={{top: '258', left: '508',transform: 'rotate(-70deg)' }} className="abs" />
        }
        {item.pieza=== 35 &&
        <Barra pieza={35}  backColor={item.colorb1} width={50} height={11} style={{top: '228', left: '513',transform: 'rotate(-82deg)' }} className="abs" />
        }
        {item.pieza=== 36 &&
        <Barra pieza={36}  backColor={item.colorb1} width={60} height={11} style={{top: '190', left: '512',transform: 'rotate(-82deg)' }} className="abs" />
        }
        {item.pieza=== 37 &&
        <Barra pieza={37}  backColor={item.colorb1} width={60} height={11} style={{top: '143', left: '517',transform: 'rotate(-85deg)' }} className="abs" />
        }
        {item.pieza=== 38 &&
        <Barra pieza={38}  backColor={item.colorb1} width={60} height={11} style={{top: '100', left: '521',transform: 'rotate(-85deg)' }} className="abs" />
        }
      </div>
      ))}
  </span>
)};
export default RenderBarras1;